// extracted by mini-css-extract-plugin
module.exports = {"Content":"Layout_Content__3sOJG"};